import React from 'react';

const Header = (props) => {
    return (
        <h1>{props.x}</h1>
    );
};

export default Header;